import { memo } from "react";
import { View } from "@src/components";
import { StyleSheet, useUnistyles } from "react-native-unistyles";

type VideoProgressBarProps = {
  currentTime: number;
  duration: number;
};

export const VideoProgressBar = memo(({ currentTime, duration }: VideoProgressBarProps) => {
  const { theme } = useUnistyles();

  if (duration <= 0) {
    return null;
  }

  const progress = (currentTime / duration) * 100;

  return (
    <View style={styles.progressBarContainer}>
      <View
        style={[
          styles.progressBar,
          {
            width: `${progress}%`,
          },
        ]}
      />
    </View>
  );
});

const styles = StyleSheet.create((theme) => ({
  progressBarContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: 4,
    backgroundColor: "rgba(255, 255, 255, 0.3)",
    borderBottomLeftRadius: theme.spacing.md,
    borderBottomRightRadius: theme.spacing.md,
    overflow: "hidden",
    zIndex: 10,
  },
  progressBar: {
    height: "100%",
    backgroundColor: theme.colors.interactive.buttons.default_background,
  },
}));
